// Analytics tracking utility for PriceStrike

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const trackEvent = async (eventType, eventName, page, element = null, metadata = null) => {
  try {
    await fetch(`${BACKEND_URL}/api/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_type: eventType,
        event_name: eventName,
        page: page,
        element: element,
        metadata: metadata
      })
    });
  } catch (error) {
    console.error('Tracking error:', error);
  }
};

// Convenience functions
export const trackPageView = (page) => {
  trackEvent('page_view', 'page_viewed', page);
};

export const trackCTAClick = (ctaName, page) => {
  trackEvent('cta_click', 'cta_clicked', page, ctaName);
};

export const trackFormSubmit = (formName, page) => {
  trackEvent('form_submit', 'form_submitted', page, formName);
};

export const trackButtonClick = (buttonName, page) => {
  trackEvent('click', 'button_clicked', page, buttonName);
};

export default {
  trackEvent,
  trackPageView,
  trackCTAClick,
  trackFormSubmit,
  trackButtonClick
};
